import { VideoProject } from "@/services/bedrock";

export interface QaIssueDraft {
  selected: Partial<Record<VideoProject.QaIssueCategory, boolean>>;
  comments: Partial<Record<VideoProject.QaIssueCategory, string>>;
}

export const EMPTY_QA_ISSUE_DRAFT: QaIssueDraft = {
  selected: {},
  comments: {},
};

export function buildQaIssues(draft: QaIssueDraft): VideoProject.QaIssue[] {
  return VideoProject.QaIssueCategories.flatMap(category => {
    if (!draft.selected[category]) return [];
    const comment = draft.comments[category]?.trim();
    return [{ category, comment: comment || null }];
  });
}
